var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHyperlink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_2",
    "data-name": "Warstwa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.31 13.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #003189;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_1-2",
    "data-name": "Warstwa 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5290-2",
    "data-name": "Group 5290-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4789",
    "data-name": "Path 4789",
    className: "cls-1",
    d: "m5.91,13.3h-3.67c-.73.02-1.43-.34-1.84-.95C.13,11.98,0,11.52,0,11.06V3.67c0-.91.58-1.73,1.43-2.05.26-.1.54-.15.82-.14h2.88c.4-.03.76.27.79.67.03.4-.26.75-.66.79-.06,0-.12,0-.18,0h-2.78c-.1,0-.21,0-.31.04-.31.09-.52.38-.52.71v1.12c0,2.08,0,4.16,0,6.24-.02.35.22.67.56.76.07.02.14.03.21.03h7.33c.42,0,.77-.33.78-.76,0-.01,0-.03,0-.04,0-.94,0-1.87,0-2.81,0-.06,0-.12,0-.17.04-.4.4-.7.8-.66.35.03.62.31.66.66,0,.04,0,.08,0,.12v2.87c.02.93-.55,1.77-1.41,2.11-.27.1-.55.15-.84.15h-3.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4790",
    "data-name": "Path 4790",
    className: "cls-1",
    d: "m10.76,1.47h-2.63c-.34,0-.64-.23-.72-.57-.09-.39.15-.79.54-.88.05-.01.11-.02.16-.02h4.39c.41-.03.76.28.79.69,0,.03,0,.06,0,.1v4.37c0,.4-.31.74-.72.75s-.74-.31-.75-.72v-2.66s-.07.07-.1.09c-2,2-4,4-6.01,6.01-.11.12-.27.21-.43.24-.4.07-.78-.2-.85-.59-.04-.2.02-.41.14-.57.04-.05.08-.09.12-.13L10.7,1.57s.05-.05.08-.08v-.02"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyperlink);
export default __webpack_public_path__ + "static/media/hyperlink.e82744ace1c359d855ad11087bc37d27.svg";
export { ForwardRef as ReactComponent };